/*!
  * shared v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function j(e, t) {
  typeof console != "undefined" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const d = {};
function F(e) {
  d[e] || (d[e] = !0, j(e));
}
const P = typeof window != "undefined";
let _, N;
if (process.env.NODE_ENV !== "production") {
  const e = P && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (_ = (t) => {
    e.mark(t);
  }, N = (t, o, n) => {
    e.measure(t, o, n), e.clearMarks(o), e.clearMarks(n);
  });
}
const $ = /\{([0-9a-zA-Z]+)\}/g;
function R(e, ...t) {
  return t.length === 1 && a(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace($, (o, n) => t.hasOwnProperty(n) ? t[n] : "");
}
const T = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), k = (e, t, o) => x({ l: e, k: t, s: o }), x = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), C = (e) => typeof e == "number" && isFinite(e), H = (e) => u(e) === "[object Date]", z = (e) => u(e) === "[object RegExp]", G = (e) => E(e) && Object.keys(e).length === 0, J = Object.assign, M = Object.create, O = (e = null) => M(e);
let h;
const V = () => h || (h = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : typeof global != "undefined" ? global : O());
function q(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function b(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function B(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (n, r, s) => `${r}="${b(s)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (n, r, s) => `${r}='${b(s)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && j("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((n) => {
    e = e.replace(n, "$1javascript&#58;");
  }), e;
}
const D = Object.prototype.hasOwnProperty;
function I(e, t) {
  return D.call(e, t);
}
const m = Array.isArray, y = (e) => typeof e == "function", U = (e) => typeof e == "string", Z = (e) => typeof e == "boolean", a = (e) => e !== null && typeof e == "object", v = (e) => a(e) && y(e.then) && y(e.catch), S = Object.prototype.toString, u = (e) => S.call(e), E = (e) => u(e) === "[object Object]", K = (e) => e == null ? "" : m(e) || E(e) && e.toString === S ? JSON.stringify(e, null, 2) : String(e);
function L(e, t = "") {
  return e.reduce((o, n, r) => r === 0 ? o + n : o + t + n, "");
}
const w = 2;
function W(e, t = 0, o = e.length) {
  const n = e.split(/\r?\n/);
  let r = 0;
  const s = [];
  for (let i = 0; i < n.length; i++)
    if (r += n[i].length + 1, r >= t) {
      for (let c = i - w; c <= i + w || o > r; c++) {
        if (c < 0 || c >= n.length)
          continue;
        const g = c + 1;
        s.push(`${g}${" ".repeat(3 - String(g).length)}|  ${n[c]}`);
        const l = n[c].length;
        if (c === i) {
          const p = t - (r - l) + 1, A = Math.max(1, o > r ? l - p : o - t);
          s.push("   |  " + " ".repeat(p) + "^".repeat(A));
        } else if (c > i) {
          if (o > r) {
            const p = Math.max(Math.min(o - r, l), 1);
            s.push("   |  " + "^".repeat(p));
          }
          r += l + 1;
        }
      }
      break;
    }
  return s.join(`
`);
}
function Q() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(o, n) {
      const r = e.get(o);
      r && r.push(n) || e.set(o, [n]);
    },
    off(o, n) {
      const r = e.get(o);
      r && r.splice(r.indexOf(n) >>> 0, 1);
    },
    emit(o, n) {
      (e.get(o) || []).slice().map((r) => r(n)), (e.get("*") || []).slice().map((r) => r(o, n));
    }
  };
}
const f = (e) => !a(e) || m(e);
function X(e, t) {
  if (f(e) || f(t))
    throw new Error("Invalid value");
  const o = [{ src: e, des: t }];
  for (; o.length; ) {
    const { src: n, des: r } = o.pop();
    Object.keys(n).forEach((s) => {
      s !== "__proto__" && (a(n[s]) && !a(r[s]) && (r[s] = Array.isArray(n[s]) ? [] : O()), f(r[s]) || f(n[s]) ? r[s] = n[s] : o.push({ src: n[s], des: r[s] }));
    });
  }
}
export {
  J as assign,
  O as create,
  Q as createEmitter,
  X as deepCopy,
  q as escapeHtml,
  R as format,
  x as friendlyJSONstringify,
  W as generateCodeFrame,
  k as generateFormatCacheKey,
  V as getGlobalThis,
  I as hasOwn,
  P as inBrowser,
  m as isArray,
  Z as isBoolean,
  H as isDate,
  G as isEmptyObject,
  y as isFunction,
  C as isNumber,
  a as isObject,
  E as isPlainObject,
  v as isPromise,
  z as isRegExp,
  U as isString,
  L as join,
  T as makeSymbol,
  _ as mark,
  N as measure,
  S as objectToString,
  B as sanitizeTranslatedHtml,
  K as toDisplayString,
  u as toTypeString,
  j as warn,
  F as warnOnce
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@intlify_shared@11.1.12/~/@intlify/shared/dist/shared.js
// module id = 440
// module chunks = 67